


































































import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import getRecentArticles from '~/queries/recentArticles.gql';
import { IBlogBlockRule, ICmsContentState } from '~/store/cms_content/types';
const _truncate = require('lodash.truncate');

interface IArticle {
  content: string;
  title: string;
  pubDate: string;
  thumbnail: string;
  link: string;
}

@Component
export default class MediumNewsFeed extends Vue {
  @State(cmsContent => (cmsContent as ICmsContentState).blogBlockRules, {
    namespace: 'cmsContent',
  })
  blogBlockRules!: IBlogBlockRule[];

  articleLimit = 4;
  articles: IArticle[] = [];

  created() {
    this.getRecentArticles();
  }

  async getRecentArticles() {
    const allBlockedKeywords =
      this.blogBlockRules?.flatMap(r => r.keywords).map(k => k.toLowerCase()) ??
      [];

    const { data } = await this.$apollo.query({
      query: getRecentArticles,
      variables: { limit: this.articleLimit },
      fetchPolicy: 'cache-first',
    });
    if (
      data &&
      data.recentArticles &&
      data.recentArticles.articles &&
      data.recentArticles.articles.length
    ) {
      this.articles = (data.recentArticles.articles as IArticle[]).filter(
        a => !allBlockedKeywords.some(k => a.content.toLowerCase().includes(k)),
      );
    }
  }

  get formattedArticles() {
    return this.articles.map(article => {
      const { title, pubDate, thumbnail, link, content } = article;

      const truncatedContent = _truncate(content, {
        length: this.calculateTruncateLength(article.title),
        separator: ' ',
      });

      return {
        content: truncatedContent,
        title,
        pubDate,
        thumbnail,
        link,
      };
    });
  }

  calculateTruncateLength(title: string) {
    const { lg, sm, xl, width } = this.$vuetify.breakpoint;
    let pLength = 18;
    let hLength = 18;
    let pLineBase = 4;
    let hLineBase = 3;

    if (sm) {
      pLength = 37;
      hLength = 28;
      pLineBase = 9;
      hLineBase = 2;
    } else if (xl) {
      pLength = 43;
      hLength = 36;
      pLineBase = 7;
      hLineBase = 2;
    } else if (width > 1564) {
      pLength = 37;
      hLength = 33;
      pLineBase = 7;
      hLineBase = 2;
    } else if (lg) {
      pLength = 29;
      hLength = 23;
      pLineBase = 5;
      hLineBase = 3;
    }
    const headingLinesCount = Math.ceil(title.length / hLength);
    const baseTruncLength = pLength * pLineBase;
    const linesToSubtract = headingLinesCount - hLineBase;

    return baseTruncLength - linesToSubtract * pLength;
  }
}
